/**
* @Author: zachalam
* @Date:   2017-02-17T16:25:05-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-17T16:25:05-08:00
*/

import map from 'lodash/map';

let initialState = {
  items: [],
  isFetching: false
};

const fav = (state = initialState, action) => {
  switch(action.type) {
    case 'REQUEST_FAVS':
      return {
        ...state,
        isFetching: true
      }

    case 'STORE_FAVS':
      const items = state.items.concat(action.payload);
      return {
        ...state,
        items,
        isFetching: false
      }
        
    case 'CLEAR_FAVS':
      return {
        items: [],
        isFetching: false
      }
        
    case 'STORE_FAV_CHANGE':
      // add/remove fav status
      console.log(action.payload);
      var newFavData = map(state.items,(v)=>{return v; });
      // swap status
      let favStatus = newFavData[action.payload].other_account.data.is_favorite;
      if(favStatus == null) newFavData[action.payload].other_account.data.is_favorite = true;
      else newFavData[action.payload].other_account.data.is_favorite = null;

      return {
        ...state,
        items: newFavData
      }
      
    default:
      return state;
  }
}

export default fav;



// WEBPACK FOOTER //
// ./src/reducers/fav.js